import React, { Component, Fragment } from "react";
import styles from "./Identification.module.sass";
import { identifierType } from "../../components/IdentificationChooser/IdentificationChooser";
import UserData from "../../components/UserData/UserData";
import IncomeIdentifier from "../../components/IncomeIdentifier/IncomeIdentifier";
import api from "../../utils/api";
import ImportantInfos from "../../components/ImportantInfos/ImportantInfos";

import FooterContent from "../../components/FooterContent/FooterContent";
import FooterChat from "../../components/FooterChat/FooterChat";
import Button from "../../components/ui/Button/Button";
import AppContext from "../../contexts/appContext";

class Identification extends Component {
  state = {
    selectedIdentifier: "",
    userData: null,
    client: "",
  };

  static contextType = AppContext;

  targetDiv = React.createRef();

  componentDidMount() {
    let document = "";
    if (this.context.ibc) {
      document =
        this.context.ibcUser.type === "1"
          ? identifierType.CPF
          : identifierType.CNPJ;
    }
    this.setState({
      selectedIdentifier: document,
    });
  }

  userDataHandler = (value) => {
    this.setState({
      userData: value,
      client: {
        origem: {
          al: false,
          cotista: false,
          nw: false,
        },
      },
    });
  };

  identifierChooserClickHandler = (type) => {
    if (type !== this.state.selectedIdentifier) {
      this.setState({
        selectedIdentifier: type,
      });
    }
  };

  confirmHandler = (incomes) => {
    const requestParams = {
      renda:
        parseFloat(incomes.primaryValue) +
        parseFloat(incomes.secondaryValue ? incomes.secondaryValue : 0),
      codigoGrupo: this.context.selectedOffer.identificacao.codigo,
      codigoBem: this.context.selectedOffer.codigoBem,
      codigoComissionado: api.CODIGO_COMISSIONADO(),
      codigoPlano: this.context.selectedOffer.dados.plano.identificacao.codigo,
      codigoTaxa: this.context.selectedOffer.dados.plano.identificacao
        .codigoTaxa,
      codigoVenda: this.context.selectedOffer.identificacao.codigoVenda,
    };

    api
      .get(api.endpoints.INCOME_VALIDATION, null, requestParams)
      .then((result) => {
        if (result.data.valida) {
          this.context.setContext({
            ...this.context,
            client: this.state.client,
            document: this.state.userData,
            incomeValue: incomes.primaryValue,
            secondaryIncomeValue: incomes.secondaryValue,
            selectedIdentifier: this.state.selectedIdentifier,
          });

          this.props.history.push({
            pathname: "/dados-cliente",
          });
        } else {
          this.context.setContext({
            ...this.context,
            error: {
              show: true,
              chat: this.state.client.origem.cotista,
              msg: !this.state.client.origem.cotista
                ? "A sua renda ainda não é compatível com a oferta escolhida. Para começar um consórcio é ideal " +
                  "ter uma renda mensal 3x maior que a parcela escolhida. Por exemplo, se o consórcio " +
                  "escolhido tiver uma parcela de R$ 600,00, você precisa ter uma renda mensal comprovada de pelo menos R$ " +
                  "1.800,00."
                : "Para começar um consórcio é ideal ter uma renda mensal 3x maior que a parcela escolhida. " +
                  "Caso queira alterar sua renda, fale com a gente no chat.",
              showChat: this.state.client.origem.cotista,
            },
          });
        }
      });
  };

  componentDidUpdate() {
    if (this.targetDiv.hasOwnProperty("scrollToDiv")) {
      this.targetDiv.scrollToDiv();
    }
  }

  render() {
    return (
      <div className={styles.contentIdentification}>
        <ImportantInfos />

        <UserData
          onChange={this.userDataHandler}
          selectedIdentifierChange={this.identifierChooserClickHandler}
          selectedIdentifier="CPF/CNPJ"
          client={this.state.client}
          document={this.context.ibc && this.context.ibcUser.cpf}
          ibc={this.context.ibc}
        />

        {this.state.client &&
          !this.state.client.origem.cotista &&
          this.state.userData && (
            <IncomeIdentifier
              ref={(el) => {
                this.targetDiv = el;
              }}
              onConfirm={this.confirmHandler}
              typeDocument={
                this.state.userData && this.state.userData.length === 11
                  ? "cpf"
                  : "cnpj"
              }
              client={this.state.client}
            />
          )}

        {this.state.client &&
          this.state.client.origem.cotista &&
          this.state.userData && (
            <Fragment>
              <div className={styles.divider} />
              <Button
                className={styles.button}
                onClick={() =>
                  this.confirmHandler({
                    primaryValue:
                      this.state.userData && this.state.userData.length === 11
                        ? this.state.client.pessoa.dadosPessoaFisica
                            .informacoesEconomicas.faixaRenda[0].valor
                        : this.state.client.pessoa.dadosPessoaJuridica
                            .informacoesEconomicas.valorFaturamento,
                    secondaryValue: 0,
                  })
                }
                selected
              >
                {" "}
                Comprar{" "}
              </Button>
            </Fragment>
          )}

        <FooterContent
          mainText="Atenção"
          text="Ao ser contemplado é preciso comprovar a renda informada."
          path="/confirmar-oferta"
          children={
            !this.context.ibc &&
            process.env.REACT_APP_DISABLE_CHAT !== "true" && (
              <FooterChat
                product={this.context.product}
                text="Fale com um especialista"
                subtext={
                  this.context.ibc
                    ? "Tire suas dúvidas aqui"
                    : "Tire suas dúvidas e continue comprando pelo chat"
                }
              />
            )
          }
        />
      </div>
    );
  }
}

export default Identification;
